<template>
  <!--
    L2 chrome. It was `ink/[0.94]` — a 94% wall of the ground's own colour over the ground,
    which is why the rail read as a solid black strip. At L2 the brand sweep pours through it
    and the rail reads as a pane rather than a slab. Fill comes from `.surface-chrome`; the
    seam border stays here because it is directional and has to flip in RTL.
  -->
  <!--
    Below `md` the rail narrows to 3.5rem. It is the one column that stays on a phone — the
    only global navigation there is — so the width has to come out of its gutters rather than
    out of the product: 4.5rem left 318px of content on a 390px screen, 3.5rem leaves 334px,
    and a 44px target still fits inside it with room on both sides.
  -->
  <div
    class="relative flex flex-col justify-between h-full w-14 md:w-[4.5rem] border-e border-slate-100 surface-chrome dark:border-white/[0.06]"
  >
    <div class="flex flex-col items-center">
      <logo
        :source="logoSource"
        :name="installationName"
        :account-id="accountId"
        class="mt-5 mb-8"
      />
      <nav class="flex flex-col items-center w-full gap-1">
        <!--
          `open-in-new-page` is forwarded, because a rail item may point OUT of this app —
          uniPUSH is a separate product on its own host, and without this it would replace the
          agent's inbox in the same tab and lose whatever they were in the middle of.
        -->
        <primary-nav-item
          v-for="menuItem in menuItems"
          :key="menuItem.toState"
          :icon="menuItem.icon"
          :name="menuItem.label"
          :to="menuItem.toState"
          :open-in-new-page="!!menuItem.openInNewPage"
          :is-child-menu-active="menuItem.key === activeMenuItem"
        />
      </nav>
    </div>
    <div class="flex flex-col items-center w-full gap-1 pb-5">
      <primary-nav-item
        v-if="!isACustomBrandedInstance"
        icon="book-open-globe"
        name="DOCS"
        :open-in-new-page="true"
        :to="helpDocsURL"
      />
      <!-- Hairline, not a rule: separation is a 1px seam, never a heavy divider. -->
      <div
        aria-hidden="true"
        class="w-8 h-px my-2 bg-slate-100 dark:bg-white/[0.06]"
      />
      <notification-bell @open-notification-panel="openNotificationPanel" />
      <agent-details
        :is-menu-open="showOptionsMenu"
        @toggle-menu="toggleOptions"
      />
      <options-menu
        :show="showOptionsMenu"
        @toggle-accounts="toggleAccountModal"
        @show-support-chat-window="toggleSupportChatWindow"
        @key-shortcut-modal="$emit('key-shortcut-modal')"
        @close="toggleOptions"
      />
    </div>
  </div>
</template>
<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import OptionsMenu from './OptionsMenu.vue';
import AgentDetails from './AgentDetails.vue';
import NotificationBell from './NotificationBell.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    OptionsMenu,
    AgentDetails,
    NotificationBell,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
      showOptionsMenu: false,
    };
  },
  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      this.$track(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('open-notification-panel');
    },
  },
};
</script>
